import { render, staticRenderFns } from "./place_interventions.vue?vue&type=template&id=0bebeddb&scoped=true&"
import script from "./place_interventions.vue?vue&type=script&lang=js&"
export * from "./place_interventions.vue?vue&type=script&lang=js&"
import style0 from "./place_interventions.vue?vue&type=style&index=0&id=0bebeddb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bebeddb",
  null
  
)

export default component.exports